import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const theme = createTheme({
  palette: {
    primary: { main: "#0f63a5" },
  },

});

const CTASection: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box
        sx={{
          py: { xs: 10, md: 14 },
          position: "relative",
          background: "linear-gradient(135deg, #0f63a5, #1e6fb8)",
          overflow: "hidden",
        }}
      >
        {/* 🔥 Pattern Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0.08,
            backgroundImage: `url("https://d2xsxph8kpxj0f.cloudfront.net/310519663388121570/Sj9Tc93iZcdrEs7R43FygC/abstract-luxury-pattern-TSiMEHvE5tcxMPkTCbnbPy.webp")`, // add subtle pattern
            backgroundSize: "cover",
          }}
        />

        <Container
          sx={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
          }}
        >
          {/* Title Line 1 */}
          <Typography
            sx={{
              fontSize: { xs: "2.2rem", md: "3.8rem" },
              color: "#fff",
              fontWeight: 500,
              lineHeight: 1.2,
            }}
          >
            Your Next Level
          </Typography>

          {/* Title Line 2 */}
          <Typography
            sx={{
              fontSize: { xs: "2.2rem", md: "3.8rem" },
              color: "#d4af37",
              fontWeight: 600,
              lineHeight: 1.2,
              mb: 3,
            }}
          >
            Starts Here
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              maxWidth: 700,
              mx: "auto",
              fontSize: { xs: "1rem", md: "1.2rem" },
              color: "rgba(255,255,255,0.85)",
              lineHeight: 1.8,
              mb: 5,
            }}
          >
            Join a team that values excellence, innovation, and your personal
            growth. Build your legacy with us.
          </Typography>

          {/* Button */}
          <Button
            endIcon={<ArrowForwardIosIcon sx={{ fontSize: 14 }} />}
            sx={{
              backgroundColor: "#ffffff",
              color: "#0f63a5",
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 500,
              fontSize: "1rem",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",

              "&:hover": {
                backgroundColor: "#f5f5f5",
                transform: "translateY(-2px)",
              },
            }}
          >
            Apply Now
          </Button>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default CTASection;